import { getAllDeliveryWindows, getOrderDetails } from '@app/ducks';
import { getDeliveryWindowsFromProducts } from '@app/logic/Orders';
import React from 'react';
import { useSelector } from 'react-redux';

import { OrderDeliveryWindowGroup } from './OrderDeliveryWindowGroup';

export const OrderProductsByDeliveryWindow = () => {
  const allDelwins = useSelector(getAllDeliveryWindows);
  const orderDetails = useSelector(getOrderDetails);
  const delwinsForOrder = React.useMemo(
    () => getDeliveryWindowsFromProducts(orderDetails.order.products, allDelwins),
    [orderDetails, allDelwins],
  );

  return (
    <div className="space-y-10">
      {delwinsForOrder.map(delwin => (
        <OrderDeliveryWindowGroup key={delwin.deliveryWindow} deliveryWindow={delwin} />
      ))}
    </div>
  );
};
